export const header = () => {

	const menuToggle = document.querySelector('.menu-toggle');
	const navMenu = document.querySelector('.nav-menu');
	const footer = document.querySelector('.footer'); 
	let menuClone = null; 

	if(menuToggle) {
		menuToggle.addEventListener('click', function () {
			const expanded = menuToggle.getAttribute('aria-expanded') === 'true' || false;
			menuToggle.setAttribute('aria-expanded', !expanded);
			navMenu.setAttribute('aria-expanded', !expanded);

			if (!expanded) {
				document.body.classList.add('no-scroll');

				const popupMenu = document.createElement('div');
				popupMenu.className = 'popup-menu';
				popupMenu.setAttribute('aria-expanded', 'true');

				if (!menuClone) {
					menuClone = navMenu.cloneNode(true);
					navMenu.innerHTML = '';
				}

				popupMenu.appendChild(menuClone);

				const closeButton = document.createElement('button');
				closeButton.className = 'popup-menu__close';
				popupMenu.appendChild(closeButton);

				footer.appendChild(popupMenu);

				setTimeout(() => {
					popupMenu.classList.add('show');
				}, 10);

				closeButton.addEventListener('click', function () {
					popupMenu.classList.remove('show');

					setTimeout(() => {
						popupMenu.remove();
						menuToggle.setAttribute('aria-expanded', 'false');
						navMenu.setAttribute('aria-expanded', 'false');

						document.body.classList.remove('no-scroll');

						if (navMenu.innerHTML === '') {
							navMenu.appendChild(menuClone);
							menuClone = null;
						}
					}, 300);
				});
			} else {

				const existingPopupMenu = footer.querySelector('.popup-menu');
				if (existingPopupMenu) {
					existingPopupMenu.classList.remove('show');

					setTimeout(() => {
						existingPopupMenu.remove();

						document.body.classList.remove('no-scroll');
					}, 300);
				}
			}

			const parentItems = document.querySelectorAll('.nav-menu__item_parent');

			parentItems.forEach(item => {
				item.addEventListener('click', function (event) {
					let submenu = item.querySelector('ul');

					const expanded = item.getAttribute('aria-expanded') === 'true' || false;
					console.log(submenu);
					item.setAttribute('aria-expanded', !expanded);
					submenu.style.display = !expanded ? 'block' : 'none';
				});
			});
		});
	}
	
	
	
	











	

}